import React from 'react'
import TableHead from '../../../procedures/Q8/Layouts/Table/TableHead'
import TableHeadCell from '../../../procedures/Q8/Layouts/Table/TableHeadCell'

type Props = {
  meta: string[]
}

const ReportTableHead = ({
  meta
}: Props) => {
  return (
          <TableHead>
            {
              meta.map((item, index) => (
                <TableHeadCell key={index}>
                  <span>{item}</span>
                </TableHeadCell>
              ))
            }
          </TableHead>
  )
}

export default ReportTableHead